import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
} from '@mui/material';
import { motion } from 'framer-motion';

// Assets
import aboutBanner from '../assets/banner.png';
import qrWhatsapp from '../assets/socials/w_qr.png';
import qrInstagram from '../assets/categories/oils.jpg';
import qrFacebook from '../assets/categories/oils.jpg';

/* ------------------ ANIMATION VARIANTS ------------------ */

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

export default function AboutUs() {
  return (
    <Box>

      {/* ================= HERO ================= */}
      <Box
        sx={{
          height: { xs: 260, md: 380 },
          backgroundImage: `linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)), url(${aboutBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Container>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            transition={{ duration: 0.8 }}
          >
            <Typography variant="h3" color="#fff" fontWeight={700}>
              About Jai Ambe Herbs & Spices
            </Typography>
            <Typography color="#f1e6d0" maxWidth={600} mt={1}>
              Authentic taste, trusted sourcing, and quality you can rely on
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* ================= OUR STORY ================= */}
      <Container sx={{ py: 8 }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={fadeUp}
          viewport={{ once: true }}
        >
          <Typography variant="h4" fontWeight={600} mb={3}>
            Our Story
          </Typography>

          <Typography color="text.secondary" maxWidth={900}>
            Jai Ambe Herbs & Spices was founded with a simple belief — purity
            should never be compromised. What started as a small sourcing
            initiative has grown into a trusted supply partner for retailers
            and wholesalers across regions.
            <br /><br />
            We work closely with farmers, ensure ethical procurement, and
            preserve the natural aroma and potency of every product.
          </Typography>
        </motion.div>
      </Container>

      {/* ================= MISSION / VISION ================= */}
      <Box sx={{ backgroundColor: '#FAF7F2', py: 8 }}>
        <Container>
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <Grid container spacing={4}>
              {[
                {
                  title: 'Our Mission',
                  text:
                    'Deliver pure, natural, and high-quality herbs and spices while ensuring hygiene, transparency, and customer satisfaction.',
                },
                {
                  title: 'Our Vision',
                  text:
                    'To become a trusted name in the spice industry through consistency, ethical sourcing, and long-term partnerships.',
                },
              ].map((item) => (
                <Grid item xs={12} md={6} key={item.title}>
                  <motion.div variants={fadeUp}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Typography variant="h5" fontWeight={600} mb={1}>
                          {item.title}
                        </Typography>
                        <Typography color="text.secondary">
                          {item.text}
                        </Typography>
                      </CardContent>
                    </Card>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Container>
      </Box>

      {/* ================= WHY TRUST US ================= */}
      <Container sx={{ py: 8 }}>
        <Typography variant="h4" fontWeight={600} mb={4}>
          Why Businesses Trust Us
        </Typography>

        <Grid container spacing={4}>
          {[
            'Direct farmer sourcing',
            'Strict quality checks',
            'Bulk & custom packaging',
            'Reliable long-term supply',
          ].map((text) => (
            <Grid item xs={12} sm={6} md={3} key={text}>
              <motion.div
                whileHover={{ y: -8 }}
                whileInView="visible"
                initial="hidden"
                variants={fadeUp}
                viewport={{ once: true }}
              >
                <Card>
                  <CardContent>
                    <Typography fontWeight={600}>
                      {text}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* ================= SOCIAL QR CONNECT ================= */}
      {/* <Box sx={{ backgroundColor: 'primary.main', color: '#fff', py: 8 }}>
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeUp}
            viewport={{ once: true }}
          >
            <Typography variant="h4" fontWeight={600} mb={2}>
              Connect With Us Instantly
            </Typography>

            <Typography maxWidth={700} mb={4}>
              Scan the QR codes below to connect with us on social platforms or
              start a direct conversation. We respond quickly.
            </Typography>

            <Grid container spacing={4}>
              {[
                // { img: qrWhatsapp, label: 'WhatsApp' },
                // { img: qrInstagram, label: 'Instagram' },
                // { img: qrFacebook, label: 'Facebook' },
              ].map((item) => (
                <Grid item xs={12} sm={4} key={item.label}>
                  <motion.div whileHover={{ scale: 1.05 }}>
                    <Stack alignItems="center" spacing={1}>
                      <Box
                        component="img"
                        src={item.img}
                        alt={item.label}
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: 2,
                          backgroundColor: '#fff',
                          p: 1,
                        }}
                      />
                      <Typography>{item.label}</Typography>
                    </Stack>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Container>
      </Box> */}

      {/* ================= CTA ================= */}
      <Box sx={{ py: 7, textAlign: 'center' }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={fadeUp}
          viewport={{ once: true }}
        >
          <Typography variant="h5" fontWeight={600}>
            Looking for a Reliable Supply Partner?
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{ mt: 2 }}
            href="/contact"
          >
            Contact Us
          </Button>
        </motion.div>
      </Box>

    </Box>
  );
}
